import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ProvisionReturnRoutes = defineRoute({
    record: {
        route: {
            path: "/provision-return",
            component: () => loadView(import("./ProvisionReturnTable.vue")),
        },
    },
    update: {
        route: {
            path: "/provision-return/update/:id",
            component: () => loadView(import("./ProvisionReturnUpdate.vue")),
        },
        build(id: string) {
            return `/provision-return/update/${id}`;
        },
    },
});
